import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IFloorplanNavigatorInteractables } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/web-components-api/floorplan_navigator_interactables';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {
  relations: [],
  select: [
    'fpni.id',
    'fpni.fpnInstanceId',
    'fpni.sourceModelType',
    'fpni.sourceModelId',
    'fpni.targetModelType',
    'fpni.targetModelId',
    'fpni.textCenterX',
    'fpni.textCenterY',
    'fpni.displayLabel',
    'fpni.styleGroup',
    'fpni.interactablePolygon',
    'fpni.interactableSvg',
    'fpni.status',
  ],
  limit: 'false',
  alias: 'fpni',
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  alias: 'fpni',
  relations: [],
  select: [
    'fpni.id',
    'fpni.fpnInstanceId',
    'fpni.sourceModelType',
    'fpni.sourceModelId',
    'fpni.targetModelType',
    'fpni.targetModelId',
    'fpni.textCenterx',
    'fpni.textCenterY',
    'fpni.displayLabel',
    'fpni.styleGroup',
    'fpni.interactablePolygon',
    'fpni.interactableSvg',
    'fpni.status',
  ],
};
const base = new StoreBaseImplementationV2<IFloorplanNavigatorInteractables>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
